module.exports = __webpack_public_path__ + "static/top-a1700452500f127ab3dfae68a2db6415.png";